import { useEffect, useState } from "react";
import ProductCard from "../../../shared/product-card/ProductCard";
import { Product } from "../../products-page/models";
import { getOtherDistributorProducts } from "../services";
import { useTranslation } from "react-i18next";
import { ProductPaginated } from "../../products-page/components/products-searched-view/models";
import { Box, Typography } from "@mui/material";
import React from "react";


export default function OtherDistributorProducts(props: any) {
    const [products, setProducts] = useState<Product[]>([]);
    const { t } = useTranslation('translation');

    useEffect(() => {
        if (props.productsObject) {
            initData(props.productsObject as ProductPaginated);
        }
        if (props.productId) {
            getOtherDistributorProducts(props.productId).then((response) => {
                 initData(response.data as ProductPaginated);
            });
        }
    }, [props.productId, props.productsObject]);

    const handleCartItemsChange = () => {
        props.onCartItemsChange();
    };

     const initData = (productPaginated: ProductPaginated): void => {
        setProducts(productPaginated.items ?? []);
    };

    return (
        <Box
            maxWidth="1400px"
            mx="auto"
            p={{ xs: 2, sm: 3, md: 4 }}
            >
            <Typography
                variant="h4"
                component="h2"
                fontWeight={600}
                textAlign="center"
                mb={3}
            >
                {props.productId ? (
                    <React.Fragment>
                        {t("productDetails.otherDistributorProducts")}
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        {t("productDetails.otherDistributorProducts")}
                    </React.Fragment>
                )}
            </Typography>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                    gap: 3,
                    justifyItems: "center",
                    alignItems: "start",
                    maxWidth: "1400px",
                    mx: "auto",
                    p: { xs: 2, sm: 3, md: 4 },
                    "& > *": {
                        maxWidth: "340px",
                        width: "100%",
                    },
                    "@media (max-width: 700px)": {
                        gridTemplateColumns: "1fr",
                        justifyItems: "center",
                    },
                }}
            >
                {products.map((product) => (
                    <ProductCard
                        product={product}
                        onCartItemsChange={handleCartItemsChange}
                        key={product.id}
                        otherProductComponent={true}
                        producerId={product.contractorId}
                    />
                ))}
            </Box>
        </Box>
    );
}
